import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ApiError } from "../types/api-error";
import { errorMessages } from "./error.messages";
import { settings } from "../helpers/toast.settings";

export const showError = (error: any) => {
  const { data, status } = error;
  const errorCode: ApiError = data.error_code;

  if (!error)
    return toast.error("Brak Połączenia z Serwerem", {
      toastId: "error",
      ...settings,
    });
  switch (status) {
    case 400:
      return toast.error(errorMessages[errorCode], {
        toastId: "400-error",
        ...settings,
      });
    // case 401:
    //   toast.error("Brak Autoryzacji", { toastId: "401-error", ...settings });
    //break;
    case 403:
      toast.error("Forbidden", { toastId: "403-error", ...settings });
      break;
    case 404:
      toast.error("Nie Znaleziono", { toastId: "404-error", ...settings });
      break;
    case 500 || 502:
      toast.error("Błąd Serwera", { toastId: "500-error", ...settings });
      break;
    default:
      if (status !== 415 && status !== 401)
        toast.error("Wystąpił Błąd", { toastId: "default-error", ...settings });
  }
};
